import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const TransactionTypeSelection = (props) => {
  const { transactionTypes, selectedTransactionType, onBack, onNext, onValueChange } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the transaction type you want to simulate</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Select the transaction type</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-transaction-type"
            options={transactionTypes}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Transaction Type" />}
            value={selectedTransactionType}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedTransactionType,
          })}
          disabled={!selectedTransactionType}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default TransactionTypeSelection;
